import { Provider } from '../../../config';
import { EventPayload } from '../../../events';
import { ScopeRequest } from '../../../services/secureIdentityProvider';
import ScopeRequestEventPayload from './scopeRequestEventPayload';

export default class ScopeRequestEventBuilder {
  static eventPayload(scopeRequest: ScopeRequest | null): EventPayload {
    if (scopeRequest) {
      return new ScopeRequestEventPayload(scopeRequest.uuid);
    }

    return {
      provider: Provider.SIP,
    };
  }
}
